import Modal from "../Modal";
import { useAuthStore } from "../../../store/auth.store";
import { useOpportunitiesStore } from "../../../store/opportunities.store";
import { useOpportunitiesCompanyDetail } from "../../../hook/partner/opportunities.partner.hook";
import { useEffect, useState } from "react";
import { NavLink } from "react-router";
import number_format from "../../../utils/number_format";
import { useTranslation } from "../../../hooks/useTranslation";

function OpportunitiesBusinessStatsModal({ filter, onHide }) {
  const { t } = useTranslation();
  const token = useAuthStore((state) => state.token);

  const opportunitiesMutation = useOpportunitiesCompanyDetail();
  const opportunities = useOpportunitiesStore(
    (state) => state.opportunitiesCompanyDetail
  );

  const [oppPage, setOppPage] = useState(1);

  useEffect(() => {
    if (token && filter) {
      opportunitiesMutation.mutate({
        token,
        page: oppPage,
        filter: { ...filter, current_state_id: [100] },
        sortTable: "opportunity_id desc",
      });
    }
  }, [oppPage, filter]);

  useEffect(() => {
    setOppPage(1);
  }, [filter]);

  const pages = (page, pages, setFunc) => {
    if (pages > 1) {
      let buttons = [];
      for (let i = 1; i <= pages; i++) {
        buttons.push(
          <button
            onClick={() => eval(setFunc + "(" + i + ");")}
            key={i}
            className={
              "btn me-3 mb-3 btn-" + (i === page ? "primary" : "secondary")
            }
          >
            {i}
          </button>
        );
      }
      return <div className="mt-3">{buttons}</div>;
    }
  };

  return (
    <Modal
      show={filter}
      title={t("opportunities.listForStats")}
      width="1000px"
      handleClose={() => onHide()}
    >
      <p>
        <strong>{t("common.found")}:</strong> {opportunities?.rows} {t("common.records")}
      </p>
      <div style={{ maxHeight: "60vh", overflow: "auto" }}>
        <table className="table align-middle table-row-dashed fs-7 gy-5 dataTable">
          <thead>
            <tr className="fw-b">
              <th>{t("opportunities.title")}</th>
              <th>{t("loans.customer")}</th>
              <th>{t("common.description")}</th>
              <th>{t("opportunities.salesperson")}</th>
              <th>{t("opportunities.invoiced")}</th>
              <th>{t("opportunities.amount")}</th>
            </tr>
          </thead>
          <tbody>
            {opportunities?.data.map((opportunity) => (
              <tr key={opportunity.opportunity_id}>
                <td>
                  <NavLink to={"/prilezitost/" + opportunity.opportunity_id}>
                    {opportunity.opportunity_id}
                  </NavLink>
                  <div>
                    {opportunity.vendors?.map((vendor) => (
                      <span
                        className={
                          "badge badge-secondary badge-vendor-" +
                          vendor.vendor_id
                        }
                      >
                        {vendor.name}
                      </span>
                    ))}
                  </div>
                </td>
                <td>
                  <NavLink
                    to={"/klient/" + opportunity.end_customer?.company_id}
                  >
                    {opportunity.end_customer?.name}
                  </NavLink>
                </td>
                <td>{opportunity.description}</td>
                <td>
                  {opportunity.sales_person?.first_name}{" "}
                  {opportunity.sales_person?.last_name}
                </td>
                <td>
                  {new Date(opportunity.invoice_date).toLocaleDateString()}
                </td>
                <td className="text-end">
                  {number_format(
                    opportunity.purchase_total_amount_local_currency,
                    2,
                    ",",
                    "."
                  ) +
                    " " +
                    opportunity.local_currency}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {pages(oppPage, opportunities?.total_pages, "setOppPage")}
    </Modal>
  );
}
export default OpportunitiesBusinessStatsModal;
